var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{ref:"ref",tag:"component",class:_vm.baseClassNames,attrs:{"data-text":_vm.text},domProps:{"innerHTML":_vm._s(_vm.genText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }